import React from 'react'
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { useGetDeviceQuery } from '../../../api/deviceApiSlice';
import { Loader } from '../../../components/components';
import PublisherGeneralDevice from '../../../components/devices/PublisherGeneralDevice';
import Title from '../../../components/Title';

const Device = () => {
  const {sptId} = useParams();
  const { t } = useTranslation();
  const history = useHistory();
  const {data: device={}, isLoading, isSuccess} = useGetDeviceQuery(sptId)

  return (
  <>
    <Title main="device" sub={sptId} onBack={() => history.push(`/devices`)} />
    <Loader success={!isLoading && isSuccess} error={!isLoading && !isSuccess}>
      <PublisherGeneralDevice device={device}/>
    </Loader>

  </>
  );
}

export default Device;